<script lang="ts">
  import type { ButterflyMedia } from '$lib/types';
  import { siteUrl } from '$lib/config';
  import getMediaUrl from '$lib/getMediaUrl';

  export let media: ButterflyMedia | null;
</script>

{#if media}
  <meta name="og:image" content="{getMediaUrl(media, { format: 'thumb', ext: 'jpg' })}" />
{:else}
  <meta name="og:image" content="{siteUrl}/thumb.jpg" />
{/if}
<meta name="og:image:width" content="1366" />
<meta name="og:image:height" content="768" />
<meta name="og:image:type" content="image/jpeg" />
